function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  d: "M30.436 38.987a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zM20.043 32.99H12.5a4.5 4.5 0 0 1-4.5-4.5V18.325a4.5 4.5 0 0 1 1.78-3.585l11.382-8.638a.5.5 0 0 1 .604-.001l11.444 8.637A4.5 4.5 0 0 1 35 18.33v3.697a10.5 10.5 0 0 1 5.936 9.46c0 5.799-4.701 10.5-10.5 10.5-5.289 0-9.664-3.91-10.393-8.997zm-.001-3c.726-5.09 5.103-9.003 10.394-9.003.531 0 1.053.039 1.563.115V18.33a1.5 1.5 0 0 0-.596-1.198l-9.934-7.497-9.876 7.495A1.5 1.5 0 0 0 11 18.325V28.49a1.5 1.5 0 0 0 1.5 1.5h7.542zm8.526-.501a1.5 1.5 0 0 0-1.664 2.496l2.7 1.8a1.5 1.5 0 0 0 1.664 0l2.7-1.8a1.5 1.5 0 1 0-1.664-2.496l-1.868 1.245-1.868-1.245z"
});

var SvgWarehousePickup = function SvgWarehousePickup(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default SvgWarehousePickup;


//////////////////
// WEBPACK FOOTER
// ./src/icons/shipment-status/warehouse-pickup.svg
// module id = 144
// module chunks = 0 1